import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface CustomDeviceList {
  deviceTemplateId: string
  deviceType: string
  commTypeId: string
  commType: string
  dataTypeId: string
  datatypeName: string
  fileName: string
  uploadStatus: string
  registers: any
  createdAt?: string | null
  modifiedAt: string | null
}
export interface customDeviceListState {
  isLoading: boolean
  loadingError: string | null
  customDeviceList: CustomDeviceList[] | null
  deviceCount: number
  httpStatus: number | null
}
const initialState: customDeviceListState = {
  isLoading: true,
  loadingError: null,
  customDeviceList: null,
  deviceCount: 0,
  httpStatus: null
}

const deviceListSlice = createSlice({
  name: 'customDeviceListSlice',
  initialState,
  reducers: {
    customDeviceListLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        customDeviceList: null,
        deviceCount: 0,
        httpStatus: 0
      }
    },
    customDeviceListUpdateAction: (state, action: PayloadAction<{ data: CustomDeviceList[], count: number, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        customDeviceList: action.payload.data,
        deviceCount: action.payload.count,
        httpStatus: action.payload.httpStatus
      }
    },
    customDeviceListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        customDeviceList: null,
        deviceCount: 0,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  customDeviceListLoadingAction,
  customDeviceListUpdateAction,
  customDeviceListErrorAction
} = deviceListSlice.actions

export default deviceListSlice.reducer
